import { TZDateMini } from '@date-fns/tz';
import { format } from 'date-fns';
import { log } from '@hungryroot/o11y';

/**
 * Returns the normalized date in the format that is commonly used internally. Maintains
 * the original date's timezone offset regardless of what timezone the client is in
 * when the method is called.
 *
 * @example
 * // Calling this method with an input containing an offset of `-04:00` in a timezone whose
 * // offset is `+09:00` will still return the original `-04:00` offset (e.g., `2023-05-25`
 * // not `2023-05-26`).
 * getNormalizedServerParameterDate('2023-05-25T19:00:00-04:00'); // '2023-05-25'
 *
 * @param {string} date
 *    The date to format. If the date is a string, it should be in the ISO-8601 format.
 */
export function getNormalizedServerParameterDate(date: string): string {
  try {
    return format(new TZDateMini(date, 'America/New_York'), 'yyyy-MM-dd');
  } catch (error) {
    log('Failed to format the normalized date with the arguments', {
      arguments,
      error,
    });
    return '';
  }
}
